import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=9cb29372&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=9cb29372&prod&lang=scss&scoped=true"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=9cb29372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb29372",
  null
  
)

export default component.exports